//=====================================================
//　来院通知チェックボックス
//=====================================================

import { useContext } from "react";
import { InputCheckBase } from "./InputCheckBase";
import { InputTag } from '../utils/ConstCommon';
import { LblInputHelper } from './LblInputHelper';
import { ConstMsg } from "../utils/ConstMsg";
import { CtxClinicSystemInfo } from "../utils/Contexts";

const FORM_TITLE = '来院通知';
const chkMail = "visit-notice-mail";
const chkSms = "visit-notice-sms";

export function ChkVisitNotice(){

    const ccsi = useContext(CtxClinicSystemInfo);

    return (
        <>
            <div className="patient-data input-box">
                <div className="input-title visit-notice">
                    <LblInputHelper title={FORM_TITLE} tag={InputTag.Optional} message={ConstMsg.IG0210001} />
                </div>
                <div className="input-box-checkbox">
                    <InputCheckBase name={chkMail} title="メールで通知する" value="1" className="agree-check" />
                </div>
                { ccsi.data.usability.smsNotification &&
                    <div className="input-box-checkbox">
                        <InputCheckBase name={chkSms} title="SMSで通知する" value="1" className="agree-check" />
                    </div>
                }
            </div>
        </>
    )

}